import * as Yup from 'yup'

export const initialValues = {
  phone: '',
  firstName: '',
  lastName: '',
  companyName: '',
  numberOfUnits: 0,
  email: '',
}

export type FormValuesType = typeof initialValues

export const formSchema = Yup.object({
  email: Yup.string().when('phone', {
    is: (phone) => !phone || phone.length === 0,
    then: () => Yup.string().required('Email is required when no phone number is provided.'),
    otherwise: () => Yup.string(),
  }),
  firstName: Yup.string().required('First Name required'),
  lastName: Yup.string().required('Last Name required.'),
  companyName: Yup.string().required('Company required.'),
  phone: Yup.string()
    .nullable()
    .matches(/^\+[1-9]\d{1,14}$/, {
      message: 'Phone must be in international format (e.g., +15555551234)',
      excludeEmptyString: true,
    }),
})
